import moment from "moment/moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ImageIcon from "../../Assets/images/VoxApp-Icon.png";
import CrossOutlineIcon from "../../Assets/svgs/CrossOutlineIcon";
import { EmailIcon } from "../../Assets/svgs/EmailIcon";
import { LocationIcon } from "../../Assets/svgs/LocationIcon";
import ModernEmailIcon from "../../Assets/svgs/ModernEmailIcon";
import { PhoneIcon } from "../../Assets/svgs/PhoneIcon";
import { dateFormat } from "../../Common/DateAndTimeFormat";
import DateSelector from "../../Common/DateSelector";
import { debounce } from "../../Common/debounce";
import { Loader } from "../../Common/Loader";
import PlusIconBtn from "../../Common/PlusIconBtn";
import ReactQuillEditor from "../../Common/ReactQuillEditor";
import TimeSelector from "../../Common/TimeSelector";
import AddVariableModal from "../../Model/AddVariableModal";
import { ErrorModel } from "../../Model/ErrorModel";
import InstantEmailModal from "../../Model/InstantEmailModal";
import LowCreditModal from "../../Model/LowCreditModal";
import { SuccessModel } from "../../Model/SuccessModel";
import { getAssistantList } from "../../Redux/Slice/Assistant/AssistantsListSlice";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import { getContactGroupById } from "../../Redux/Slice/Contacts/Contact Group/GetContactGroupByIdSlice";
import { scheduleEmail } from "../../Redux/Slice/Contacts/Email/ScheduleEmailSlice";
import { updateScheduledEmail } from "../../Redux/Slice/Contacts/Email/UpdateScheduledEmailSlice";
import { getContactById } from "../../Redux/Slice/Contacts/GetContactByIdSlice";
import { Emails } from "./Emails";
import MembersList from "./MembersList";
import { maskPhoneNumber } from "../../Common/utils";

export const ScheduleEmail = () => {
  const dispatch = useDispatch();
  const buttonRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const isForContactGroup = location.pathname.includes("/group-email");

  const [contactId, setContactId] = useState("");
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEditForm] = useState(false);
  const [hasChange, setHasChange] = useState(false);
  const [isToday, setIsToday] = useState(false);
  const [showLowCreditModal, setShowLowCreditModal] = useState(false);
  const [formData, setFormdata] = useState({
    emailDate: "",
    startTime: "",
    assistant: "",
    assistantId: "",
    subject: "",
    description: "",
  });
  const [members, setMembers] = useState([]);
  const [UserDetails, setUserDetails] = useState({
    name: "",
    phoneNumber: "",
    countryCallingCode: "",
    address: {
      address: "",
      city: "",
      state: "",
      country: "",
      zipcode: "",
    },
  });
  const [formError, setFormError] = useState({
    dateError: "",
    timeError: "",
    subjectError: "",
    descriptionError: "",
  });
  const [assistants, setAssistants] = useState([]);
  const [showInstantEmailPopup, setShowInstantEmailPopup] = useState({
    visible: false,
    data: null,
  });
  const [addVariableModalVisible, setAddVariableModalVisible] = useState({
    variableFor: null,
    visible: false,
  });

  const AssistantList = useSelector((state) => state.assistants.assistantsList);

  const getContactDetails = async (id) => {
    const getByIdAction = isForContactGroup
      ? getContactGroupById
      : getContactById;

    const result = await dispatch(getByIdAction(id));
    if (
      getByIdAction.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      const data = result.payload.data;

      setUserDetails({
        name: isForContactGroup
          ? data?.name
          : data?.firstName + " " + data?.lastName,
        email: data?.email,
        avatar: data?.avatar,
        lastCallDetails: data?.lastContactDate ? data?.lastContactDate : "",
        phoneNumber: data?.phoneNumber
          ? maskPhoneNumber(data?.phoneNumber, data?.countryCallingCode, false)
          : "",
        countryCallingCode: data?.countryCallingCode,
        address: {
          address: data?.address?.address,
          city: data?.address?.city,
          state: data?.address?.state,
          country: data?.address?.country,
          zipcode: data?.address?.zipCode,
        },
      });
      if (Array.isArray(data?.contacts)) {
        setMembers(data?.contacts);
      }
    }
  };

  useEffect(() => {
    FetchAssistantsList();
    let userId = location.pathname.split("/")[2];
    setContactId(userId);
    getContactDetails(userId);
  }, []);

  const FetchAssistantsList = async () => {
    await dispatch(getAssistantList({ text: "", isDropdown: true }));
  };

  useEffect(() => {
    if (AssistantList) {
      setAssistants(AssistantList.data);
    }
  }, [AssistantList]);

  function compareTimes(time1, time2) {
    const parseTime = (time) => {
      const [timePart, modifier] = time.split(" ");
      let [hours, minutes] = timePart.split(":").map(Number);
      return hours * 60 + minutes; // Return total minutes
    };
    const totalMinutes1 = parseTime(time1);
    const totalMinutes2 = parseTime(time2);

    if (totalMinutes1 < totalMinutes2) {
      return true;
    } else {
      return false;
    }
  }

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const compareDate = (val1, val2) => {
    if (
      val1.getDate() === val2.getDate() &&
      val1.getMonth() === val2.getMonth() &&
      val1.getFullYear() === val2.getFullYear()
    ) {
      return true;
    } else {
      return false;
    }
  };

  function convertTimeToHHMM(time) {
    // Check if the input is in the expected format
    const regex = /^\d{2}:\d{2}:\d{2}$/;
    if (!regex.test(time)) {
      throw new Error("Input must be in hh:mm:ss format");
    }

    // Split the time string into parts
    const parts = time.split(":");
    // Return the hours and minutes
    return `${parts[0]}:${parts[1]}`;
  }

  function compareCurrentTime(givenTime) {
    // Get the current date and time
    const now = new Date();
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();
    const [givenHours, givenMinutes] = givenTime.split(":").map(Number);
    if (
      currentHours > givenHours ||
      (currentHours === givenHours && currentMinutes > givenMinutes)
    ) {
      return true;
    } else if (
      currentHours < givenHours ||
      (currentHours === givenHours && currentMinutes < givenMinutes)
    ) {
      return false;
    } else {
      return false;
    }
  }

  const handleChange = (e) => {
    let { value, name } = e.target;
    if (!hasChange) {
      setHasChange(true);
    }
    dispatch(setUnsavedChanges(true));
    setFormdata({ ...formData, [name]: value });
    if (name === "emailDate") {
      let errors = formError;
      setFormdata({ ...formData, [name]: dateFormat(value) });
      if (compareDate(new Date(value), new Date())) {
        setIsToday(true);
        errors = {
          ...formError,
          dateError: "",
        };
        if (formData.startTime != "") {
          if (compareCurrentTime(formData.startTime)) {
            errors = {
              ...formError,
              timeError: "Start Time cannot be less than now.",
            };
          } else {
            errors = {
              ...formError,
              timeError: "",
            };
          }
        }
      } else if (new Date(value) < new Date()) {
        setIsToday(false);
        errors = {
          ...formError,
          dateError: "Call Date cannot be in the past.",
        };
      } else {
        setIsToday(false);
        errors = {
          ...formError,
          dateError: "",
        };
      }
      if (formData.startTime) {
        const isTodayDate = moment(value, "DD/MM/YYYY").isSame(
          moment(),
          "date"
        );
        if (isTodayDate) {
          if (compareCurrentTime(formData.startTime)) {
            errors = {
              ...formError,
              timeError: "Start Time cannot be less than now.",
            };
          } else {
            errors = {
              ...formError,
              timeError: "",
            };
          }
        } else {
          errors = {
            ...formError,
            timeError: "",
          };
        }
      }
      setFormError(errors);
    } else if (name === "startTime") {
      const isTodayDate =
        isToday ||
        moment(formData.emailDate, "DD/MM/YYYY").isSame(moment(), "date");
      if (isTodayDate) {
        if (compareCurrentTime(value)) {
          setFormError({
            ...formError,
            timeError: "Start Time cannot be less than now.",
          });
        } else {
          setFormError({
            ...formError,
            timeError: "",
          });
        }
      }
    } else if (name === "assistantId") {
      const assistant = assistants.find((x) => x.id === value);
      if (assistant) {
        setFormdata((prev) => ({
          ...prev,
          subject: assistant?.email?.subject || "",
          description: assistant?.email?.description || "",
          assistant: assistant.name,
          [name]: value,
        }));
      } else {
        setFormdata({ ...formData, [name]: value, assistant: assistant.name });
      }
    } else if (name === "subject") {
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      const isValid = !(value?.length < 3);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, subjectError: "" });
      } else {
        setFormError({
          ...formError,
          subjectError: "Subject must be between 3 and 100 characters long",
        });
      }
      setFormdata({
        ...formData,
        subject: value,
      });
    } else if (name === "description") {
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      const isValid = !(value?.length < 3);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, descriptionError: "" });
      } else {
        setFormError({
          ...formError,
          descriptionError: "Message must be between 3 and 100 characters long",
        });
      }
      setFormdata({
        ...formData,
        description: value,
      });
    }
  };

  const handleCancel = (name) => {
    if (name === "emailDate") {
      setFormdata({ ...formData, emailDate: "" });
    } else if (name === "time") {
      setFormdata({ ...formData, startTime: "" });
    } else if (name === "assistant") {
      setFormdata({ ...formData, assistant: "", assistantId: "" });
    }
  };
  const dateUTCFormat = (date, time) => {
    const localDateTime = moment(`${date} ${time}`, "DD/MM/YYYY HH:mm");
    const utcDateTime = localDateTime.utc().format();
    return utcDateTime;
  };
  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      if (!isEdit) {
        let body = {
          date: dateUTCFormat(formData.emailDate, formData.startTime),
          emailTime: formData.startTime,
          subject: formData.subject,
          description: formData.description,
          assistantId: formData.assistantId, // single select
        };
        if (isForContactGroup) {
          body.contactGroupIds = [contactId];
        } else {
          body.contactIds = [contactId];
        }

        const result = await dispatch(scheduleEmail(body));
        if (
          scheduleEmail.fulfilled.match(result) &&
          result?.payload?.success === true
        ) {
          setIsLoading(false);
          dispatch(setUnsavedChanges(false));
          setSuccessMessage("Email Scheduled Successfully!");
          setSuccessModel(true);
          setTimeout(() => {
            setSuccessModel(false);
            navigate(-1);
          }, 1500);
        } else {
          setIsLoading(false);
          const apiErrorMessage =
            result?.payload?.error &&
            typeof result?.payload?.error?.message == "string" &&
            result?.payload?.error?.message
              ? result?.payload?.error?.message
              : null;
          const apiErrorCode =
            result?.payload?.error && result?.payload?.error?.code
              ? result?.payload?.error?.code
              : null;
          if (apiErrorCode == 1030) {
            setShowLowCreditModal(true);
          } else {
            setErrorMessage(apiErrorMessage ?? "Something went wrong.");
            setErrorModel(true);
            setTimeout(() => {
              setErrorModel(false);
            }, 1500);
          }
        }
      } else {
        const body = {
          id: formData.id,
          date: dateUTCFormat(formData.emailDate, formData.startTime),
          emailTime: formData.startTime,
          description: formData.description,
          subject: formData.subject,
          assistantId: formData.assistantId,
        };

        const result = await dispatch(updateScheduledEmail(body));
        if (
          updateScheduledEmail.fulfilled.match(result) &&
          result?.payload?.success === true
        ) {
          setIsLoading(false);
          dispatch(setUnsavedChanges(false));
          setSuccessMessage("Email Updated Successfully!");
          setSuccessModel(true);
          setTimeout(() => {
            setSuccessModel(false);
            navigate(-1);
          }, 1500);
        } else {
          setIsLoading(false);
          setErrorMessage(result?.payload?.error?.message);
          setErrorModel(true);
          setTimeout(() => {
            setErrorModel(false);
          }, 1500);
        }
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const onEdit = (emailData) => {
    setHasChange(false);
    dispatch(setUnsavedChanges(false));
    setIsEditForm(true);
    setFormdata({
      id: emailData.id,
      emailDate: dateFormat(emailData.date),
      startTime: convertTimeToHHMM(emailData.emailTime),
      assistant: emailData?.assistant?.name,
      assistantId: emailData?.assistant?.vapiAssistanceId,
      subject: emailData?.subject,
      description: emailData.description,
    });
    if (buttonRef.current) {
      buttonRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const onClickInstantCall = () => {
    setShowInstantEmailPopup({
      visible: true,
      data: {
        id: contactId,
        ...UserDetails,
      },
    });
  };

  const onSubmitAddVariable = (variable) => {
    setFormdata((p) => ({
      ...p,
      [addVariableModalVisible.variableFor]:
        p[addVariableModalVisible.variableFor] == "string"
          ? p[addVariableModalVisible.variableFor] + variable
          : variable,
    }));
    setAddVariableModalVisible({
      visible: false,
      variableFor: null,
    });
  };

  const closeInstantCallPopup = (value = "default", error = null) => {
    setShowInstantEmailPopup({
      visible: false,
      data: null,
    });
    if (value === "success") {
      setSuccessMessage("Email Sent successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
      }, 1500);
    } else if (value === "error") {
      setIsLoading(false);
      const apiErrorMessage =
        error && typeof error?.message == "string" ? error?.message : null;
      const apiErrorCode = error && error?.code ? error?.code : null;
      if (apiErrorCode == 1030) {
        setShowLowCreditModal(true);
      } else {
        setErrorMessage(apiErrorMessage ?? "Something went wrong.");
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    }
  };

  const debouncedSubmit = debounce(handleSubmit, 300);

  return (
    <div className="page__body">
      {isLoading ? <Loader /> : ""}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {showInstantEmailPopup.visible ? (
        <InstantEmailModal
          closePopup={closeInstantCallPopup}
          currentContact={showInstantEmailPopup.data}
          isForContactGroup={isForContactGroup}
        />
      ) : null}
      {addVariableModalVisible?.visible ? (
        <AddVariableModal
          assistantId={formData?.assistantId}
          onSubmit={onSubmitAddVariable}
          onClose={() =>
            setAddVariableModalVisible({
              variableFor: null,
              visible: false,
            })
          }
        />
      ) : null}

      <div className="CreateScheduleCall">
        <div className="CreateScheduleCall__row CreateScheduleCall__row__2">
          <div className="CreateScheduleCall__row__col">
            <div className="CreateScheduleCall__card">
              <div className="CreateScheduleCall__card__body">
                <div className="scheduleCallProfile">
                  <div className="scheduleCallProfile__profile">
                    <div className="initials initials--bgBlue">
                      {UserDetails.avatar ? (
                        <img src={UserDetails.avatar ?? ImageIcon} alt="" />
                      ) : (
                        String(UserDetails?.name)[0]
                      )}
                    </div>
                    <div className="info">
                      <h4 className="name">{UserDetails.name}</h4>
                    </div>
                    <div className="btn__group">
                      <button
                        className="btn btn__primary"
                        onClick={onClickInstantCall}
                      >
                        <ModernEmailIcon />
                        Send Email
                      </button>
                    </div>
                  </div>
                  <div className="scheduleCallProfile__Detail">
                    <div className="scheduleCallProfile__Detail__card">
                      <ul className="list list--noWrap">
                        {/* <li>  
                          <span className="icon">
                            <svg
                              width="20"
                              height="19"
                              viewBox="0 0 20 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="10.0095"
                                cy="9.54297"
                                r="8.45703"
                                stroke="#475569"
                                stroke-width="1.5"
                              />
                              <ellipse
                                cx="10.0104"
                                cy="9.54297"
                                rx="3.84411"
                                ry="8.45703"
                                stroke="#475569"
                                stroke-width="1.5"
                              />
                              <path
                                d="M1.55249 10.3086H18.4666"
                                stroke="#475569"
                                stroke-width="1.5"
                                stroke-linecap="round"
                              />
                            </svg>
                          </span>
                          www.voxappnewapp.co.in
                        </li> */}
                        {UserDetails.address.address ||
                        UserDetails.address.zipcode ? (
                          <li>
                            <span className="icon">
                              <LocationIcon />
                            </span>
                            <span className="textValue">
                              {UserDetails.address.address
                                ? UserDetails.address.address
                                : ""}{" "}
                              {UserDetails.address.city != ""
                                ? ", " + UserDetails.address.city
                                : ""}{" "}
                              {UserDetails.address.state != ""
                                ? ", " + UserDetails.address.state
                                : ""}{" "}
                              {UserDetails.address.zipcode != ""
                                ? ", " + UserDetails.address.zipcode
                                : ""}
                              {UserDetails.address.country
                                ? ", " + UserDetails.address.country
                                : ""}
                            </span>
                          </li>
                        ) : (
                          ""
                        )}
                        {!isForContactGroup ? (
                          <>
                            <li>
                              <span className="icon">
                                <EmailIcon />
                              </span>
                              {UserDetails.email}
                            </li>
                            <li>
                              <span className="icon">
                                <PhoneIcon />
                              </span>
                              {UserDetails.countryCallingCode}{" "}
                              {UserDetails.phoneNumber}
                            </li>
                          </>
                        ) : (
                          <>
                            <h5>
                              Group Members{" "}
                              <span className="count">{members?.length}</span>
                            </h5>
                            <div className="participant">
                              <MembersList members={members} />
                            </div>
                          </>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="CreateScheduleCall__row__col">
            <div className="CreateScheduleCall__card">
              <div className="CreateScheduleCall__card__head" ref={buttonRef}>
                Email Scheduling Details
              </div>
              <div className="CreateScheduleCall__card__body">
                <div className="scheduleCall">
                  <div className="scheduleCall__row">
                    <p className="para">
                      <strong>Note:</strong> You can schedule email with more
                      than one assistant with different time slots.
                    </p>
                  </div>
                  <div className="scheduleCall__row scheduleCall__row--divider">
                    <div className="form__Field">
                      <label for="emailDate" className="form__label">
                        Email Date<sup className="form__label__asterisk">*</sup>
                      </label>
                      {formData.emailDate === "" ||
                      formError.dateError != "" ? (
                        <DateSelector
                          name="emailDate"
                          value={formData.emailDate}
                          onChange={handleChange}
                          placeholder="DD/MM/YYYY"
                          minDate={moment()}
                        />
                      ) : (
                        <div className="btn__group">
                          <button className="btnScheduleCall btnScheduleCall--success">
                            {formData.emailDate}
                            <div onClick={() => handleCancel("emailDate")}>
                              <CrossOutlineIcon />
                            </div>
                          </button>
                        </div>
                      )}
                      {formError.dateError ? (
                        <div className="form__error">{formError.dateError}</div>
                      ) : null}
                    </div>
                    <div className="form__Field">
                      <label for="emailTime" className="form__label">
                        Email Time<sup className="form__label__asterisk">*</sup>
                      </label>
                      {formData.startTime === "" ||
                      formError.timeError != "" ? (
                        <>
                          <TimeSelector
                            type="time"
                            id="emailTime"
                            name="startTime"
                            value={formData.startTime}
                            onChange={handleChange}
                            placeholder="00:00"
                          />
                          {formError.timeError ? (
                            <div className="form__error">
                              {formError.timeError}
                            </div>
                          ) : null}
                        </>
                      ) : (
                        <div className="btn__group">
                          <button className="btnScheduleCall">
                            {formData.startTime}
                            <div onClick={() => handleCancel("time")}>
                              <CrossOutlineIcon />
                            </div>
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="form__Field">
                      <label for="assistant" className="form__label">
                        Assistant<sup className="form__label__asterisk">*</sup>
                      </label>
                      {formData.assistantId === "" ? (
                        <select
                          className="form__select form__select--sm"
                          id="assistant"
                          name="assistantId"
                          value={formData.assistantId}
                          onChange={handleChange}
                        >
                          <option selected="" value="" disabled>
                            -Select-
                          </option>
                          {assistants
                            ? assistants.map((assistant) => (
                                <option value={assistant.id}>
                                  {assistant.name}
                                </option>
                              ))
                            : ""}
                        </select>
                      ) : (
                        <div className="btn__group">
                          <button className="btnScheduleCall btnScheduleCall--primary">
                            {/* <img src="/images/create-assistant-img01.jpg" alt="" /> */}
                            {formData.assistant}
                            <div onClick={() => handleCancel("assistant")}>
                              <CrossOutlineIcon />
                            </div>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="scheduleCall__row">
                    <div className="form__Field form__Field--full">
                      <label
                        for="subject"
                        className="form__label form__label--flex"
                      >
                        <span>
                          Subject<sup className="form__label__asterisk">*</sup>
                        </span>
                        {formData.assistantId ? (
                          <PlusIconBtn
                            onClick={() =>
                              setAddVariableModalVisible({
                                variableFor: "subject",
                                visible: true,
                              })
                            }
                          />
                        ) : null}
                      </label>
                      <input
                        id="subject"
                        className="form__input form__input--sm"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        placeholder="Subject"
                        maxLength={100}
                      />
                      {formError?.subjectError ? (
                        <div className="form__error">
                          {formError.subjectError}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="scheduleCall__row">
                    <div className="form__Field form__Field--full">
                      <label
                        for="description"
                        className="form__label form__label--flex"
                      >
                        <span>
                          Message<sup className="form__label__asterisk">*</sup>
                        </span>
                        {formData.assistantId ? (
                          <PlusIconBtn
                            onClick={() =>
                              setAddVariableModalVisible({
                                variableFor: "description",
                                visible: true,
                              })
                            }
                          />
                        ) : null}
                      </label>
                      {/* <textarea
                        id="description"
                        className="form__textarea"
                        name="description"
                        maxLength={500}
                        value={formData.description}
                        onChange={handleChange}
                        placeholder="Message"
                      ></textarea> */}
                      <ReactQuillEditor
                        id="description"
                        name="description"
                        theme="snow"
                        value={formData.description}
                        style={{ width: "100%" }}
                        placeholder="Enter your message here..."
                        onChange={(value) => {
                          if (!hasChange) {
                            setHasChange(true);
                          }
                          dispatch(setUnsavedChanges(true));
                          setFormdata({ ...formData, description: value });
                        }}
                      />
                      {formError?.descriptionError ? (
                        <div className="form__error">
                          {formError.descriptionError}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="scheduleCall__row">
                    <div className="btn__group">
                      <button
                        className="btn btn__white"
                        onClick={() => {
                          setFormdata({
                            emailDate: "",
                            startTime: "",
                            assistant: "",
                            assistantId: "",
                            description: "",
                            subject: "",
                          });
                          setFormError({
                            dateError: "",
                            timeError: "",
                            subjectError: "",
                            descriptionError: "",
                          });
                          setIsEditForm(false);
                        }}
                      >
                        Clear
                      </button>
                      <button
                        className="btn btn__primary"
                        disabled={
                          !hasChange ||
                          formData.emailDate === "" ||
                          formError.dateError != "" ||
                          formData.startTime === "" ||
                          formData.subject === "" ||
                          formData.description === "" ||
                          formError.timeError != "" ||
                          formData.assistantId === "" ||
                          formError.subjectError ||
                          formError.descriptionError
                        }
                        onClick={debouncedSubmit}
                      >
                        {isEdit ? "Update" : "Schedule"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Emails onEdit={onEdit} isForContactGroup={isForContactGroup} />
      </div>
      {showLowCreditModal ? (
        <LowCreditModal onClose={() => setShowLowCreditModal(false)} />
      ) : null}
    </div>
  );
};
